export const en = {
  message: {
    layout: {
      login: 'Login',
      logout: 'Logout',
      dashboard: 'Dashboard',
      stampTime: 'Stamp Time',
      projects: 'Projects',
      hourlogging: 'Hour logging',
      approval: 'Approval',
      reports: 'Reports',
      settings: 'Settings',
      user: 'User',
      activities: 'Activities',
      members: 'Members',
      worktypes: 'Worktypes',
      holidays: 'Holidays',
      companySettings: 'Company settings',
      sharepointSettings: 'Sharepoint Settings',
      project: 'Project',
      company: 'Company',
      customerLogin: 'Customer login'
    },
    dashboard: {
      hoursDetails: 'Total Hours',
      employeeDetails: 'Per Employee',
      dayDetails: 'Per Day',
      userHours: 'Hourlog Details',
      hourState: 'Hours state',
      overviewHours: 'Overview Hours'
    },
    login: {
      language: 'Language',
      back: 'Back',
      userName: 'Username',
      password: 'Password',
      authFailed: 'Authentication failed !',
      enterUserName: 'Enter User Name',
      enterPassword: 'Enter Password',
      enterConfirmPassword: 'Confirm Your Password',
      resetNow: 'Reset Now',
      invalidPassword: 'Invalid Password',
      unauthorizedMsg: 'Authentication failed!',
      error: 'Error',
      contactAdmin: 'Please Contact Administrator',
      retry: 'Retry',
      redirectToSo: 'Please wait while we redirect to SuperOffice'
    },
    common: {
      translate: 'Translate',
      required: 'Required',
      refresh: 'Refresh',
      name: 'Name',
      english: 'English',
      norwegian: 'Norwegian',
      save: 'Save',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
      updateAndClose: 'Update & Close',
      close: 'Close',
      new: 'New',
      isActive: 'Is active',
      isDefault: 'Is default',
      addNew: 'Add new',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Added successfully !',
      updatedSuccess: 'Updated successfully !',
      deleteSuccess: 'Deleted successfully !',
      backToList: 'Back To List',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      deleteMsg: 'Deleted Successfully',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Delete Confirm',
      areYouSure: 'Are you sure you want to delete ?',
      includeAttachment: 'Do you need to include documents on report?',
      validationIssue: 'Please check the required fields!',
      noResults: 'No results found !',
      noRecords: 'No Records Found!',
      position: 'Position',
      changedPassword: 'Password Changed Successfully',
      invalidEmail: 'Invalid Email',
      invalidNumber: 'Invalid Number',
      ok: 'Ok',
      date: 'Date',
      comments: 'Comments',
      status: 'Status',
      description: 'Description',
      others: 'Others',
      total: 'Total',
      actions: 'Actions',
      color: 'Color',
      year: 'Year',
      month: 'Month',
      responsible: 'Responsible',
      attachments: 'Attachments',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
      download: 'Download',
      details: 'Details',
      report: 'Report',
      updatedOn: 'Updated on',
      confirmation: 'Confirmation',
      startDate: 'Start Date',
      endDate: 'End Date',
      clear: 'Clear',
      email: 'E-mail',
      all: 'All',
      state: 'State',
      addWorkType: 'Add worktype',
      updateWorkType: 'Update worktype',
      addHoliday: 'Add Holiday',
      updateHoliday: 'Update Holiday',
      addProject: 'Add Project',
      updateProject: 'Update Project',
      addActivity: 'Add Activity',
      updateActivity: 'Update Activity',
      task: 'Task',
      cost: 'Cost',
      number: 'Number',
      sync: 'Sync',
      image: 'Image',
      estimatedHours: 'Estimated Hours',
      receivedPayment: 'Received Payment',
      employee: 'Employee',
      syncStarted: 'The syncing is started!',
      type: 'Type',
      select: 'Select',
      weekTotalHours: 'Week hrs',
      logoutSuccess: 'You have been successfully logged out!',
      selectUsers: 'Select Users',
      approvalHours: 'Approval Hours',
      newUpdate: 'New Update Available!',
      weekNotExists: 'Week not exists',
      invalidHours: 'Invalid hours',
      canDeliverHours: 'Can Deliver Hours',
      active: 'Active',
      completed: 'Completed',
      logoImage: 'Logo image',
      uploadedSuccess: 'Uploaded successfully !',
      hoursDetails: 'Hour Details'
    },
    timer: {
      start: 'Start',
      stop: 'Stop',
      pause: 'Pause',
      resume: 'Resume',
      selectProjects: 'Select Projects',
      selectEmployees: 'Select Employees',
      go: 'Go',
      approveHours: 'Approve Hours',
      approvedHours: 'Approved Hours',
      notApprovedHours: 'Not Approved Hours',
      approve: 'Approve',
      notApprove: 'Not Approve',
      addHours: 'Add Hour',
      notApproved: 'Not approved comments',
      amount: 'Amount',
      selectEntries: 'Select Entries',
      deliver: 'Deliver',
      totalHours: 'Total Hours',
      timer: 'Timer',
      hours: 'Hours',
      editHours: 'Edit Hours',
      deliveredSuccessfully: 'Delivered Successfully !',
      noHours: 'No hours',
      approved: 'Approved',
      notApprovedMsg: 'Not approved',
      delivered: 'Delivered',
      notDelivered: 'Not Delivered',
      workType: 'Work type',
      finder: 'Finder',
      findersFee: 'Finder\'s fee'
    },
    reports: {
      perProject: 'Per Project',
      perActivity: 'Per Activity',
      perEmployee: 'Per Employee',
      filterActions: 'Filter Actions',
      selectProject: 'Select Project',
      selectEmployees: 'Select Employees',
      runReport: 'Run report',
      onlySum: 'Show Only Sum',
      showEstimation: 'Show Estimation',
      sendReport: 'Send Report',
      emailNote: 'Please use comma(,) to add multiple email ids',
      emailValidation: 'E-mail must be valid',
      fileType: 'File Type',
      onlyXlsx: 'Only xslx',
      onlyPdf: 'Only PDF',
      both: 'Both',
      sentSuccess: 'Report sent successfully',
      includeDependent: 'Include Dependent',
      salesPrice: 'Sales price',
      totalSalesPrice: 'Total sales',
      totalCostPrice: 'Total cost',
      from: 'From',
      till: 'Till',
      consumptionSalt: 'Cons.salt',
      hourSalting: 'Hours salting',
      hourPlowing: 'Hours plowing',
      timesSalting: 'No.Of salting',
      timesPlowing: 'No.Of plowing',
      saltQuantity: 'Salt Qauntity',
      mgQuantity: 'MG Quantity',
      amountT: 'amount',
      totalSaltingPeriod: 'Tot hour salting selected period',
      totalPlowingPeriod: 'Tot hour plowing selected period',
      totalQtySaltingPeriod: 'Tot Quantity salting selected period',
      totalQtyPlowingPeriod: 'Tot Quantity brewing selected period',
      totalSaltSelected: 'Tot quantity salt selected period',
      totalMGSelected: 'Tot quantity MG selected period',
      total: 'Total hours',
      estimation: 'Estimation',
      progress: 'Progress',
      userCost: 'User Cost',
      cost: 'Cost',
      allEmployeesProjectHours: 'Grand total',
      totalProjectHours: 'Total project hours',
      receivedPaymentProgress: 'Paid fees in % of an account'
    },
    stamp: {
      project: 'Project',
      activity: 'Activity'
    },
    sharepointSettings: {
      config: 'SharePoint Configurations',
      credential: 'SharePoint Credentials',
      baseUrl: 'Base url',
      siteUrl: 'Site url',
      listName: 'List name',
      loadFolders: 'Load folders',
      loadList: 'Load List',
      propertiesConfig: 'Properties Configuration',
      contentType: 'Content Type',
      companyRootFolder: 'Select Company Folder',
      projectRootFolder: 'Select Project Folder'
    },
    hse: {
      hseSystem: 'HSE-SYSTEM',
      uploadDocument: 'Upload Document',
      gettingFolders: 'Loading... Please wait...',
      noDocuments: 'NO DOCUMENTS FOUND!',
      noFolders: 'NO FOLDERS FOUND!',
      createNew: 'Create',
      editName: 'Edit folder',
      deleteFolder: 'Delete folder',
      upload: 'Upload',
      folderName: 'Folder name',
      files: 'Files',
      noResponsible: '*no responsible',
      noDescription: '*no description',
      updateMetaData: 'Update Meta Data',
      openNewTab: 'Open in new Tab',
      editMeta: 'Edit Meta',
      rename: 'Rename',
      versionHistory: 'Version History',
      versionLabel: 'Version Label',
      size: 'Size',
      modifiedBy: 'Modified By',
      modifiedOn: 'Modified On',
      title: 'Title',
      searchFound: 'Search Results : Found',
      createdSuccess: 'Created successfully!',
      renameSuccess: 'Renamed successfully!'
    }
  }
}
